export default "__VITE_ASSET__BYPYLlwk__"